<myclubrewards-notice></myclubrewards-notice>
<ng-container *ngIf="promotions$ | async as promotion">
  <div class="wrapper-header">
    <myclubrewards-editable-card-header
      [config]="promotion"
    ></myclubrewards-editable-card-header>
  </div>
  <myclubrewards-promotion-primary
    *ngIf="promotion.promotions.primary"
    [promotion]="promotion.promotions.primary"
  ></myclubrewards-promotion-primary>
  <ng-container>
    <div class="card-wrapper">
      <div class="gift-back"></div>
      <div class="gift-card-box">
        <myclubrewards-card
          *ngFor="let item of promotion.promotions.secondary"
          [config]="item"
          class="gift-card"
        ></myclubrewards-card>
      </div>
    </div>
  </ng-container>
</ng-container>
